<div class="col-md-12 text-center p-5" style="background-color: #fff;" *ngIf="cad_list.length <= 0">
	<img src="../../../assets/img/nothing.png" class="img-fluid pt-5">
</div>
<div class="col-md-12">
	<div class="row pt-5">
	  <div class="col-md-4 mt-4" *ngFor="let obj of cad_list">
	    <div class="card card-chng">

	    	<img onerror="this.src='./assets/img/no_image.svg';" class="card-img-top img-fluid" src="{{obj.cad_drawing}}" alt="Card image cap" style="max-height: 165px;" />

	      <!-- <img class="card-img-top img-fluid" src="{{obj.cad_drawing}}" alt="Card image cap" style="max-height: 165px;"> -->
	      <div class="card-block" style="padding: 1rem;">
	        <p class="card-text" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;border-bottom: 1px solid #e0e0e0;padding-bottom: 10px;">{{obj.name}}</p>
	        <div class="row">
	          <div class="col-md-12">
	            <p class="mb-0" style="font-size:13px;">
	              <span>{{obj.details}} </span>
	            </p>
	            <p class="mb-0 mt-2" style="font-size:13px;">
	              <span>Uploaded at: </span>
	              <span style="color: #7E7E7E;">{{obj.updated_at | date:'dd MMMM, y - h:mm a'}}</span>
	            </p>
	          </div>
	          <div class="col-md-12 divbutton mt-2">
	            <a class="btn btn-pink btn-chng pull-right" href="{{obj.cad_drawing}}" download>
	              Download
	            </a>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/category-cad-elevation/category-cad-elevation.component.html